import { Destination2 } from '~/models/Destination'
import { DestinationSnippet } from '~/models/DestinationSnippet'
import { Page } from '~/models/PaginatedItems'
import { Activity } from '~/models/Product'
import { BaseRepository } from '../baseRepository'
import { ApiActivity } from '../product/apiType'
import { ProductEntityMapper } from '../product/entityMapper'
import { ApiPage, toPage } from '../shared/pagination'
import { ApiDestination, ApiDestinationStamp } from './apiTypes'
import { DestinationMapperEntity } from './toEntity'

export class DestinationRepository extends BaseRepository {
	private static resource = 'v1/destinations'

	static async getDestination(destinationId: string): Promise<Destination2> {
		const response: ApiDestination = await this.get(`${this.resource}/${destinationId}/`)
		return DestinationMapperEntity.toDestination(response)
	}

	static async getStamp(destinationId: string): Promise<string> {
		const response: ApiDestinationStamp = await this.get(`${this.resource}/${destinationId}/stamp`)
		return response.country_stamp_url as string
	}

	static async find(placeId: string): Promise<Destination2> {
		return await this.findBy({ place_id: placeId })
	}

	static async findByIsoCode(iso: string): Promise<Destination2> {
		return await this.findBy({ iso_code: iso })
	}

	static async getActivities(destinationId: string): Promise<Page<Activity>> {
		const response: ApiPage<ApiActivity> = await this.get(
			`${this.resource}/${destinationId}/activities`,
			{
				page: 0,
				page_size: 10,
			}
		)
		const activities = ProductEntityMapper.toActivities(response.results)
		return toPage(response, activities)
	}

	static async getSnippets(destinationId: string): Promise<DestinationSnippet[]> {
		const response: DestinationSnippet[] = await this.get(
			`${this.resource}/${destinationId}/snippets/`
		)
		return DestinationMapperEntity.toSnippets(response)
	}

	static async search(
		searchText: string,
		pageSize: number,
		page: number
	): Promise<Page<Destination2>> {
		const params = {
			q: searchText,
			page,
			page_size: pageSize,
		}
		const response: ApiPage<ApiDestination> = await this.get(`${this.resource}/search/`, params)
		const destinations = DestinationMapperEntity.toDestinations(response.results)
		return toPage(response, destinations)
	}

	private static async findBy(params: {
		place_id?: string
		iso_code?: string
	}): Promise<Destination2> {
		const response: ApiDestination = await this.get(`${this.resource}/find/`, params)
		return DestinationMapperEntity.toDestination(response)
	}
}
